import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SidePanelService {
  private toggle = new Subject<boolean>();
  private config$ = new Subject<any>();
  public toggle$ = this.toggle.asObservable();

  setConfig(config: any) {
    this.config$.next(config);
  }

  getConfig$() {
    return this.config$;
  }

  openSidePanel(config: any) {
    this.config$.next(config);
    this.toggle.next(true);
  }
}
